module.exports = __webpack_public_path__ + "img/4.d8be85a4.png";